import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

type StatusIndicatorProps = {
  isMaintenanceOk?: boolean;
  isTestOk?: boolean;
}

const StatusIndicator = ({ isMaintenanceOk, isTestOk }: StatusIndicatorProps) => {
  const { t } = useTranslation();

  const okColor = '#53c41a';
  const notOkColor = '#f5222d';

  const maintenanceBorder = isMaintenanceOk ? okColor : notOkColor;
  const testBorder = isTestOk ? okColor : notOkColor;
  const maintenanceFill = isMaintenanceOk ? okColor : notOkColor;
  const testFill = isTestOk ? okColor : notOkColor;

  return (
    <div style={{ width: 18, height: 18, borderRadius: '50%', padding: 1, background: `linear-gradient(to right, ${maintenanceBorder} 50%, ${testBorder} 50%)` }}>
      <div style={{ display: 'flex', width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden' }}>
        <Tooltip title={t('entities.tools.state.maintenance')}>
          <div style={{ flex: 1, height: '100%', backgroundColor: maintenanceFill }} />
        </Tooltip>
        <Tooltip title={t('entities.tools.state.test')}>
          <div style={{ flex: 1, height: '100%', backgroundColor: testFill }} />
        </Tooltip>
      </div>
    </div>
  );
};

export default StatusIndicator;
